import React from 'react';
import { Head2 } from '../head2/Head2';

export const Main2 = () => {
	return (
		<>
			<Head2 />
		</>
	);
};
